import {ModuleWithProviders, NgModule} from "@angular/core";
import {PopoverRenderer} from "./PopoverRenderer";
import {DOMPopoverRenderer} from "./dom/DOMPopoverRenderer";
import {PopoverCollection} from "./PopoverCollection";
import {DOMPopoverCollection} from "./dom/DOMPopoverCollection";
// BUG: do not fix path, see https://github.com/dherges/ng-packagr/issues/734
// noinspection TypeScriptPreferShortImport
import {PopoverWindowComponent} from "./directives/popover-window/n-popover-window.component";
import {PopoverService} from "./PopoverService";
import {PopoverConfig} from "./PopoverConfig";

@NgModule({
  declarations: [
    PopoverWindowComponent
  ], // directives, components, and pipes owned by this NgModule
  imports: [],
  exports: [],
  providers: [],
  entryComponents: [
    PopoverWindowComponent,
  ]
})
export class NPopoversModule {
  static forRoot(): ModuleWithProviders<NPopoversModule> {
    return {
      ngModule: NPopoversModule,
      providers: [
        PopoverService,
        PopoverConfig,
        {provide: PopoverCollection, useClass: DOMPopoverCollection},
        {provide: PopoverRenderer, useClass: DOMPopoverRenderer},
      ]
    };
  }
}
